import React, { Component } from 'react';
import { map, orderBy } from 'lodash';
import PropTypes from 'prop-types';
import { withApollo } from 'react-apollo';
import PubSub from '../src/services/PubSub';
import GetABMResources from '../src/components/graphql/getABMResources';
import QueryGroups from '../src/components/graphql/getABMGroups';
import {
    Button,
    Drawer,
    HasPermissions,
    Loading,
    NotFound,
    Container,
    Main,
    FlexContainer
} from '../src/components/common';
import PermissionCard from '../src/components/sections/Permissions/PermissionCard';
import PermissionForm from '../src/components/sections/Permissions/PermissionForm';
import ModalDelete from '../src/components/sections/Permissions/ModalDelete';
import { _get } from '../src/utils/misc';

class Permissions extends Component {
    state = {
        currentSelected: [],
        currentResourceSelected: 'generic',
        activeProduct: null,
        pageSize: 50,
        currentPage: 1,
        loading: false,
        editMode: false,
        drawerVisible: false,
        modalVisible: false,
        visible: false,
        iconName: null,
        textInfo: null
    };

    componentDidMount() {
        PubSub.dispatch('SET_RIGHT_HEADER', () => this.rightHeader());
    }

    componentWillUnmount() {
        PubSub.dispatch('SET_RIGHT_HEADER', () => '');
    }

    toggleEditMode = (item) => {
        this.setState({
            editMode: true,
            drawerVisible: !this.state.drawerVisible,
            currentSelected: item
        });
    };

    toggleClose = () => {
        this.setState({
            editMode: false,
            drawerVisible: !this.state.drawerVisible,
            currentSelected: {}
        });
    }

    toggleCreateMode = () => {
        this.setState({
            editMode: false,
            drawerVisible: !this.state.drawerVisible
        });
    };

    _toggleModal = (iconName, textInfo) =>
        this.setState(({ visible }) => ({
            visible: !visible,
            iconName,
            textInfo
        }));

    onSubmitSuccess = () => this.toggleCreateMode();

    rightHeader = () => (
        <HasPermissions to={['permissions-page:edit']}>
            <Button
                text='Crear Permiso'
                style={{ whiteSpace: 'nowrap', marginLeft: '15px' }}
                onClick={this.toggleCreateMode}
            />
        </HasPermissions>
    );

    _onModalClose = (editMode) => {
        this.setState({ drawerVisible: false, editMode: editMode || false, currentSelected: {} });
    };

    handleModal = (item) => {
        this.setState({ modalVisible: !this.state.modalVisible, currentSelected: item });
    }
    

    render() {
        const { editMode, drawerVisible, currentSelected } = this.state;

        return (
            <HasPermissions
                to={['permissions-page:view']}
                otherwise={
                    <NotFound
                        firstTextLine='Página no encontrada'
                        style={{ minHeight: '90vh' }}
                    />
                }
            >
                <GetABMResources fetchPolicy='network-only'>
                    {({ data, loading }) => {
                        return (
                            <QueryGroups fetchPolicy='network-only'>
                                {({ data: profilesData }) => {
                                    return <Container>
                                        <Main
                                            style={{
                                                minHeight: 280,
                                                height: '100%',
                                                background: '#f4f4f4'
                                            }}
                                            withFooter
                                        >
                                            <Loading loading={loading}>
                                                <FlexContainer shrink={0} grow={1} direction='column'>
                                                    <FlexContainer wrap>
                                                        {map(orderBy(data, ['alias'], 'asc'), (item) => {
                                                            return <PermissionCard handleModal={this.handleModal} item={item} onEdit={this.toggleEditMode} profilesData={profilesData} />
                                                        })}
                                                    </FlexContainer>
                                                </FlexContainer>
                                                <Drawer
                                                    width='700px'
                                                    closable
                                                    title={`${editMode ? 'Editar' : 'Crear'} Permiso`}
                                                    visible={drawerVisible}
                                                    onClose={() => this._onModalClose(editMode)}
                                                >
                                                    <PermissionForm
                                                        editMode={editMode}
                                                        initialValues={currentSelected}
                                                        render={this.renderForm}
                                                        onSubmitSuccess={this.toggleClose}
                                                        onReset={this.toggleEditMode}
                                                        enableReinitialize
                                                    />
                                                </Drawer>
                                            </Loading>
                                        </Main>
                                    </Container>
                                }}
                            </QueryGroups>
                        );
                    }}
                </GetABMResources>
                <ModalDelete visible={this.state.modalVisible} toggleModal={this.handleModal} permission={this.state.currentSelected} client={this.props.client} />
            </HasPermissions>
        );
    }
}

Permissions.propTypes = {
    session: PropTypes.object,
    client: PropTypes.object
};

export default withApollo(Permissions);
